import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import KeywordResearch from "./pages/KeywordResearch";
import SerpAnalysis from "./pages/SerpAnalysis";
import OnPageAudit from "./pages/OnPageAudit";
import Users from "./pages/Users";
import Account from "./pages/Account";
import KnowledgeBase from "./pages/KnowledgeBase";
import Changelog from "./pages/Changelog";
import AISearch from "./pages/AISearch";
import SiteXRay from "./pages/SiteXRay";
import Settings from "./pages/Settings";
import Layout from "./components/Layout";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f7fafc] text-[#1a202c]">
        <div className="font-mono-tight text-sm text-[#a0aec0]">
          Initializing&hellip;
        </div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="light"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#ffffff",
              color: "#1a202c",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              boxShadow: "0 8px 24px -8px rgba(45,55,72,0.12)",
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/clients/:id/:section" element={<ClientDetail />} />
            <Route path="/tools/keyword-research" element={<KeywordResearch />} />
            <Route path="/tools/serp" element={<SerpAnalysis />} />
            <Route path="/tools/on-page" element={<OnPageAudit />} />
            <Route path="/tools/ai-search" element={<AISearch />} />
            <Route path="/tools/site-xray" element={<SiteXRay />} />
            <Route path="/knowledge-base" element={<KnowledgeBase />} />
            <Route path="/changelog" element={<Changelog />} />
            <Route path="/users" element={<Users />} />
            <Route path="/account" element={<Account />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
